import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};

import { DeviceUUID } from "device-uuid"

const state = {
  isLoadEspaces: false,
  espaces: [],
  espacesSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadEspaces: state => state.isLoadEspaces,
  espaces: state => state.espaces,
};

const mutations = {
  getEspacesSuccess(state, payload) {
    state.isLoadEspaces = true;
    state.espaces = payload.espaces;
  },
  addEspaceSuccess(state, payload) {
    // console.log({payload});
    // console.log("FROMMUATETTAGSUCCES");
    state.isLoadEspaces = true;
    let espaces = state.espaces;
    espaces.push(payload.data);
    state.espaces = espaces;
  },
  updateGlobalPlanSuccess(state, payload) {
  
  },
  editEspaceSuccess(state, payload) {
    console.log("FROM MUTATE");
    console.log(payload);
    state.isLoadEspaces = true;
    let espaces = state.espaces;

    let newEspaces = [];
    espaces.map((espace, index) => {
      if (espace._id == payload.data._id) {
        newEspaces.push({ ...payload.data });
      } else {
        newEspaces.push({ ...espace });
      }
    });
    state.espaces = [...newEspaces];
  },
  deleteEspaceSuccess(state, payload) {
    state.isLoadEspaces = true;
    let espaces = state.espaces;

    let newEspaces = [];
    espaces.map((espace, index) => {
      if (espace._id != payload.data._id) {
        newEspaces.push({ ...espace });
      }
    });
    state.espaces = [...newEspaces];
  },
  
  getEspacesError(state, error) {
    state.isLoadEspaces = false;
  },
  addEspaceError(state, error) {
    state.isLoadEspaces = false;
  }
};

const actions = {
  getEspaces({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/espaces/${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getEspacesSuccess", {
            espaces: res.data
          });
        } else {
          commit("getEspacesError", "error:getEspaces");
        }
      });
  },
  getEspaces1({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/espaces/${payload.restaurant}?containerHeight=${payload.containerHeight}&containerWidth=${payload.containerWidth}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getEspacesSuccess", {
            espaces: res.data
          });
        } else {
          commit("getEspacesError", "error:getEspaces");
        }
      });
  },
  addEspace({ commit }, payload) {
    return axios
      .post(`${apiPath}/espaces`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addEspaceSuccess", res);
        } else {
          commit("addEspaceError", "error:addEspace");
        }
        return res;
      });
  },
  updateGlobalPlan({ commit }, payload) {
    return axios
      .post(`${apiPath}/global/plan`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("updateGlobalPlanSuccess", res);
        } else {
          commit("addEspaceError", "error:addEspace");
        }
        return res;
      });
  },
  editEspace({ commit }, payload) {
    return axios
      .put(`${apiPath}/espaces/${payload.id}`, payload.data, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editEspaceSuccess", res);
        } else {
          commit("addEspaceError", "error:addEspace");
        }
        return res;
      });
  },
  deleteEspace({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };

    console.log({config})
    return axios
      .delete(`${apiPath}/espaces/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        return payload;
      });
  },
 
};

export default {
  state,
  getters,
  mutations,
  actions
};
